import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, SquareChevronRight } from "lucide-react";
import { reviews, installers } from "../mock";

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const timer = useRef(null);
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  useEffect(() => {
    timer.current = setInterval(() => setIndex((i) => (i + 1) % reviews.length), 5000);
    return () => clearInterval(timer.current);
  }, []);

  const prev = () => setIndex((i) => (i - 1 + reviews.length) % reviews.length);
  const next = () => setIndex((i) => (i + 1) % reviews.length);
  const r = reviews[index];

  return (
    <section id="reviews" className="bg-grey px-4 md:px-[30px] pb-10" data-testid="installers-section">
      <div className="max-w-[1140px] mx-auto">
        <div className="banner-shape text-center py-5 px-4 bg-fire" style={{ "--shape-fill": "#fff" }}>
          <h3 className="text-charcoal font-normal text-[30px] md:text-[28px]">{installers.heading}</h3>
        </div>

        <div className="bg-white p-[10px] md:p-5 text-center">
          <p className="text-charcoal text-[16px] leading-relaxed">{installers.body1}</p>
          <p className="text-charcoal text-[16px] leading-relaxed mt-3">{installers.body2}</p>

          <h5 className="text-charcoal font-medium text-[17px] md:text-[20px] mt-8">{installers.areasHeading}</h5>
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-4" data-testid="areas-list">
            {installers.areas.map((a) => (
              <li key={a} className="inline-flex items-center gap-1.5 text-[17px] md:text-[18px] font-medium" style={{ color: "#5D5D5D" }}>
                <SquareChevronRight className="text-fire" size={15} /> {a}
              </li>
            ))}
          </ul>

          <h5 className="text-charcoal font-medium text-[16px] md:text-[20px] mt-9">
            Don't just take our word for it, see our extensive customer reviews
          </h5>

          <div className="relative max-w-3xl mx-auto mt-6 px-10" data-testid="reviews-carousel">
            <div className="relative bg-grey rounded-md p-6 md:p-8 shadow-sm min-h-[150px] flex items-center justify-center">
              <p className="text-charcoal text-[16px] leading-relaxed" data-testid="review-text">“ {r.text}”</p>
              <span className="absolute left-1/2 -bottom-2 -translate-x-1/2 border-l-[10px] border-r-[10px] border-t-[10px] border-l-transparent border-r-transparent border-t-[#F2F2F2]" />
            </div>
            <div className="mt-5">
              <p className="text-charcoal font-medium text-[16px]" data-testid="review-name">{r.name}</p>
              <p className="text-fire text-sm">{r.place}</p>
            </div>
            <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 text-charcoal/60 hover:text-fire transition-colors" aria-label="Previous" data-testid="review-prev">
              <ChevronLeft size={28} />
            </button>
            <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 text-charcoal/60 hover:text-fire transition-colors" aria-label="Next" data-testid="review-next">
              <ChevronRight size={28} />
            </button>
          </div>

          <button onClick={() => go("#quote")} className="btn-fire mt-8 px-6 py-3 text-[14px] md:text-[17px]" data-testid="installers-quote-button">
            Get My Free Quote
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
